import { memo, useMemo } from "react"
import { DTO_RoadCondition, DTO_Weather } from "../../../../services/calls/types/maps"

import './index.scss'
import { MAP_ITEM_INFO } from "./data"
import InfoDisplay, { DisplayData } from "../../../InfoDisplay"
import { LAYER_TYPE } from "../.."

type MapData = {
  data: DTO_RoadCondition | DTO_Weather
  type: LAYER_TYPE
}

const MapDataDisplay = memo(({ data, type }: MapData) => {
  const dataInfo = useMemo(() => {
    return MAP_ITEM_INFO[type].infoArr.reduce((arr: DisplayData[], info) => {
      const { label, path, type: infoType, formatFunction } = info
      let value = data[path]
      if (path === 'road_colors') {
        value = (
          <div
            className="MapData__icon"
            style={{
              backgroundColor: value[0],
              border: `2px solid ${value[1]}`
            }}
          />
        )
      } else if (formatFunction && value) {
        value = formatFunction(value, data)
      }

      arr.push({
        label,
        value,
        type: infoType
      })
      return arr
    }, [])
  }, [data, type])

  return (
    <div className="MapData">
      <InfoDisplay data={dataInfo} />
    </div>
  )
})

export default MapDataDisplay
